<div
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
  class="connect-bg connect-channel"
>
  <h2>{{ titleText }}</h2>
  <h3>{{ step1TitleText }}</h3>
  <button
    mat-raised-button
    fxFlex="none"
    type="submit"
    (click)="launchWhatsAppSignup()"
  >
    {{ embeddedSignupText }}
  </button>
  @if (showCoexistenceButton()) {
    <button
      mat-raised-button
      fxFlex="none"
      type="submit"
      (click)="launchWhatsAppCoexistenceSignup()"
    >
      {{ embeddedSignupCoexistenceText }}
    </button>
  }

  <h3 [ngClass]=""> {{ step2TitleText }} </h3>
  @if (feedback) {
    <p class="text-feedback"> {{ problemGettingPhoneNumberText }} </p>
  }

  @if (noPhoneNumbersFeedback) {
    <p>
      {{ noPhoneNumbersText }}
      <span class="refresh-fb-pages" (click)="launchWhatsAppSignup()"
        >{{ refreshText }}<mat-icon>refresh</mat-icon></span
      >
    </p>
  }
  @if (phoneNumbers && phoneNumbers?.length) {
    <p> {{ messagesSentText }} </p>
  }

  @if (loadingPhoneNumbers) {
    <div fxFlexAlign="center" @loadData>
      <mat-spinner [diameter]="32" [strokeWidth]="3.2"></mat-spinner>
    </div>
  }

  @if (phoneNumbers && !loadingPhoneNumbers) {
    <div
      fxFlex
      fxLayout="row"
      fxLayoutAlign="center center"
      class="phones-select"
    >
      <mat-select
        fxFlex="none"
        [(ngModel)]="selectedPhoneNumber"
        floatPlaceholder="never"
      >
        @for (phone of phoneNumbers; track phone) {
          <mat-option [value]="phone">
            <span
              >({{ phone.display_phone_name }}) {{ phone.display_phone_number }}
            </span>
          </mat-option>
        }
      </mat-select>
    </div>
  }
  <button
    mat-raised-button
    fxFlex="none"
    type="submit"
    [disabled]="!(phoneNumbers && selectedPhoneNumber)"
    (click)="addWhatsappCloud()"
  >
    {{ connectPhoneNumberText }}
  </button>
</div>
